export default __webpack_public_path__ + "static/media/laser-hair-removal.119074bc.JPG";